// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1196":"6d9b3654","3252":"c19957a9","4470":"ece97403","4542":"97cdc108","5146":"97cdc108","6311":"22720fc1","7354":"81b03039","9040":"ece97403"}[chunkId] + ".chunk.css";
};